import axios from "axios";
import {
  CalendarEvent,
  isCalendarEventVisible,
} from "../../models/economic-calendar/CalendarEvent";

const BASE_URL = import.meta.env.VITE_ECONOMIC_CALENDAR_BASE_URL;

export const client = axios.create({
  baseURL: BASE_URL,
});

export const fetchCalendarEventsByDay = async (day: Date) => {
  // Adjust for timezone offset to get the correct day in UTC
  // The .toISOString by default uses UTC timezone, so we need to adjust the date to user local timezone
  const offset = day.getTimezoneOffset();

  const dateString = new Date(day.getTime() - offset * 60 * 1000)
    .toISOString()
    .split("T")[0];

  const response = await client.get("/calendar_events", {
    params: {
      by_day: dateString,
    },
  });

  // Only include events where category.state is "visible"
  const filteredData = (response.data as CalendarEvent[]).filter(
    isCalendarEventVisible
  );

  return filteredData;
};
